import { runQuery } from 'src/api/apollo/runQuery';
import { GET_COMPANY } from 'src/api/graphql/queries/company.gql';

export const getCompanyById = async (id) => {
	const { data } = await runQuery({
		query: GET_COMPANY,
		variables: {
			id: String(id),
		},
		fetchPolicy: 'network-only',
	});

	return data;
};
